import common from "../web-sh/src/services/common"

export default {
  ...common
}